"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PopperMenu = _interopRequireDefault(require("../PopperMenu"));

var _Icons = require("../../foundation/Icons");

var _KubraSVG = _interopRequireDefault(require("../../assets/images/KubraSVG"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TopBar = function TopBar(props) {
  var getIcon = function getIcon() {
    var isKubra = props.isKubra,
        isAdmin = props.isAdmin; // client admin

    if (!isKubra && isAdmin) {
      return /*#__PURE__*/_react.default.createElement(_Icons.IcoUser, null);
    } // kubra employee


    if (isKubra && !isAdmin) {
      return /*#__PURE__*/_react.default.createElement(_Icons.IcoCrown, null);
    } // kubra admin


    if (isKubra && isAdmin) {
      return /*#__PURE__*/_react.default.createElement(_Icons.IcoCrown, {
        className: "kubra-admin-ico"
      });
    } // client employee


    return null;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "topbar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "topbar__logo"
  }, /*#__PURE__*/_react.default.createElement(_KubraSVG.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "topbar__right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "selected-client"
  }, getIcon(), props.displayName), props.menuItems && /*#__PURE__*/_react.default.createElement("div", {
    className: "topbar__menu"
  }, /*#__PURE__*/_react.default.createElement(_PopperMenu.default, {
    menuPlacement: "bottom-end",
    referenceElement: /*#__PURE__*/_react.default.createElement(_Icons.IcoEllipsisV, null)
  }, props.menuItems))));
};

TopBar.propTypes = {
  displayName: _propTypes.default.string.isRequired,
  isKubra: _propTypes.default.bool.isRequired,
  isAdmin: _propTypes.default.bool.isRequired,
  menuItems: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
var _default = TopBar;
exports.default = _default;